export { default } from './DtrSummaryNew.js';